var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460 300",
    style: {
      enableBackground: "new 0 0 460 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#E9EDF2;}\n\t.st3{fill:#C5E6FF;}\n\t.st4{fill:#B08E68;}\n\t.st5{fill:#25D284;}\n\t.st6{fill:#261F18;}\n\t.st7{fill:#818D99;}\n\t.st8{fill:#FFFFFF;}\n\t.st9{fill:#AAB3BA;}\n\t.st10{fill:#EADEFC;}\n\t.st11{fill:#E3A98A;}\n\t.st12{fill:#434343;}\n\t.st13{fill:#3CA4F3;}\n\t.st14{fill:#173B56;}\n\t.st15{fill:#D5DCE1;}\n\t.st16{fill:#416F91;}\n\t.st17{fill:#0F2535;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 785.5,
    y: -320.7,
    className: "st2",
    width: 300,
    height: 300
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Artwork"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M413.4,255c0,0,37.9-12.8,41.1-40c3.2-27.2-11.4-39.8-23.1-50.7c-11.7-10.9-11.2-18.2-15.9-27.5 c-15.2-29.5-52.3-43-81.8-39c-29.6,3.9-35.6,15.5-47.3,18.5c-11.7,3-21.5,8.4-24,19.7c-2.5,11.4-1.6,26.9-11.1,33.8 c-9.5,7-25.9,17.7-27.2,34.4c-1.3,16.8,6.3,45.5,41.4,50.7C300.5,260.3,413.4,255,413.4,255z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M321,116.3c0,0,7.8,7.7,18.2,7.2c10.5-0.5,17.1-7.2,17.1-7.2l-1.9-11.8c0,0,9.5-19.9,7.9-26.6 c-1.6-6.6-14.2-14.1-23.1-14c-8.9,0.1-22.7,8.9-24,15.7C313.9,86.5,321,116.3,321,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.8,117.6c0,0-21.2-0.7-30.2,12.7c-8.9,13.3-13.1,32.9-11.5,47.2c1.6,14.2,9.5,26.6,19.9,30.6 c6.1,2.3,77.3,1.3,77.3,1.3s14.1-3.1,19-18.2c4.9-15.1-1.3-46.9-9.5-58.3c-8.2-11.5-31.4-16.5-31.4-16.5s-9.7,7.4-19,6.9 C327.9,122.8,322.8,117.6,322.8,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M320.7,78c0,0,6.2,4.8,13.9,3.4c7.7-1.4,11.1-10.2,11.1-10.2s2.4,7,9.8,7.2c0.2,3.7,0.2,5.8-0.1,8.8 c-0.1,1,4.6,1,4.1,4.1c-0.6,3.7-4.5,2.5-4.7,3.5c-2.2,8.5-5.8,12.8-5.8,12.8s7.2,9,7.6,17.9c0.4,8.9,0,26.6,7.7,27 c7.7,0.4,16.3-13.4,13.6-27.7c-2.6-14.2-10.8-18.1-10-27.7c0.8-9.6-0.2-34.2-10.1-43.8c-9.9-9.6-17.4-5-17.4-5s-12.8-4.3-20.2,6 c-6.2,8.5-9.3,24.1-7.5,35.1c1.8,11-3.5,23-6.9,27.2c-3.5,4.3-9.8,24.8-1.6,32.3c8.1,7.5,16.8-1.5,15.7-13.3 c-1-11.8,7.9-28.7,7.9-28.7s-3.7-4.5-6.1-12.3c-0.3-1-4.5,0.5-5-3.3c-0.5-3.6,4.2-3.2,4-4.3C320.3,83.7,320.2,82.4,320.7,78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M305.2,222.8c0,0,22.1,14,40.4,11.6c18.3-2.5,36.3-15.5,36.3-15.5s-17.7-12.9-41.1-12.1 C317.3,207.6,305.2,222.8,305.2,222.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M304.8,218h71.9c2,0,3.7-1.5,3.9-3.5l5.1-48c0.2-2.3-1.6-4.3-3.9-4.3h-82.1c-2.3,0-4.1,2-3.9,4.3l5.1,48 C301.1,216.5,302.8,218,304.8,218z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M344.4,234.6c0,0,28.5-24,40.8-32.4c12.3-8.4,29.5-16.3,39.2-13c9.7,3.3,6.8,20.1,1,24 c-25.5,17-76.4,32-76.4,32L344.4,234.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M349.2,250.1c0,0,10.9,5,20.3,4.4c9.4-0.7,12.2-1.2,12.9-4.1c0.7-3-11.5-9-18.7-9.7 c-7.2-0.7-11.2-0.6-11.2-0.6L349.2,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M342.2,248.5c0,0-10.4,5.9-19.9,6.1c-9.4,0.1-12.3-0.1-13.2-3c-0.9-2.9,10.7-10,17.8-11.2 c7.1-1.3,11.1-1.5,11.1-1.5L342.2,248.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M352.6,240c0,0-44.8-33.4-58.9-38.8c-14.1-5.4-33.4-8.2-39.2-4.3c-5.8,3.9-6.3,13,5.9,21.9 c12.3,8.9,71.4,29.8,88.9,31.3C354.3,246.7,352.6,240,352.6,240z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.287 -0.9579 0.9579 0.287 60.8393 461.9913)",
    className: "st2",
    cx: 340.8,
    cy: 190.1,
    rx: 6.8,
    ry: 6.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45,259.4c0,0-37.9-12.8-41.1-40c-3.2-27.2,11.4-39.8,23.1-50.7c11.7-10.9,11.2-18.2,15.9-27.5 c15.2-29.5,52.3-43,81.8-39c29.6,3.9,35.6,15.5,47.3,18.5c11.7,3,21.5,8.4,24,19.7c2.5,11.4,1.6,26.9,11.1,33.8 c9.5,7,25.9,17.7,27.2,34.4c1.3,16.8-6.3,45.5-41.4,50.7C157.8,264.6,45,259.4,45,259.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M121.7,33.8c0,0,18.3,2.9,15.5,31.5c-2.8,28.6-18.9,22.2-20,22.2c-1.1,0-16.2,4.6-17.4-30.4 C99.8,57.2,99.3,31.3,121.7,33.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M137.5,57.2c0,0,2-2.1,2.7,0c0.7,2.2-2.7,11.8-2.9,12.3c0,0-0.4,0.8-0.8,0.4 C136,69.5,137.5,57.2,137.5,57.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M100.3,56.9c0,0-2-2.2-2.7,0c-0.8,2.2,2.5,11.9,2.6,12.3c0,0,0.3,0.8,0.8,0.4 C101.5,69.1,100.3,56.9,100.3,56.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M137.5,61.6l-2.6,3.5c0,0,0.1-7.7-0.3-8.9c-0.4-1.2-1.1-4.9-1.4-5.8c-0.4-0.9-15.7-5.2-29.3,1.3 c0,0,0.6,5.5-0.7,6c-1.3,0.5-0.7,9-0.7,9l-2.2-2.4c0,0-3.3-22-2.5-24.3c0.8-2.3,3.4-16.1,31.3-7.9c0,0,8.7-1.8,10.4,4.2 C141.2,42.2,137.5,61.6,137.5,61.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M130.8,95.3C130.8,95.2,130.8,95.2,130.8,95.3c-1.2-2.6-0.6-11-0.6-11s-23.3-5.9-22.6-1.4 c0.7,4.5-2,12.8-2,12.8l-12,4.1c0,0,12.7,34.2,27.4,29.8c14.6-4.4,20.2-31,20.2-31L130.8,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.3,97.9c0,0-22.6,0.5-32.9,15.8c-10.2,15.3-16,37.8-14.2,54.1c1.8,16.3,11.8,30.4,23.7,35 c6.9,2.6,88.5,1.5,88.5,1.5s17.6-4,23.3-21.3c5.6-17.3-2.4-54.2-11.7-67.3c-9.4-13.1-36.6-18-36.6-18s-11.1,8.5-21.8,7.9 C106.8,105.1,99.3,97.9,99.3,97.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M80.8,219.7c0,0,25.3,16.1,46.3,13.3c21-2.8,41.5-17.8,41.5-17.8s-20.3-14.8-47.1-13.8 S80.8,219.7,80.8,219.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M82,212.4H161c2.2,0,4-1.7,4.3-3.9l5.6-52.6c0.3-2.5-1.7-4.8-4.3-4.8h-90c-2.6,0-4.5,2.2-4.3,4.8l5.6,52.6 C78,210.8,79.8,212.4,82,212.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M125.6,231c0,0,32.7-30.7,46.8-41.5c14.1-10.8,33.8-20.9,44.9-16.7c11.1,4.2,7.8,25.7,1.1,30.7 c-29.2,21.8-87.5,41-87.5,41L125.6,231z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M131.2,250.9c0,0,12.5,5.8,23.2,5c10.8-0.8,14-1.3,14.8-4.7c0.8-3.4-13.2-10.3-21.4-11.1 c-8.2-0.8-12.8-0.7-12.8-0.7L131.2,250.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M123.1,249.1c0,0-12,6.8-22.7,6.9c-10.8,0.1-14.1-0.1-15.1-3.5c-1.1-3.3,12.3-11.4,20.4-12.8 c8.1-1.4,12.7-1.7,12.7-1.7L123.1,249.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M135,238c0,0-51.3-42.8-67.5-49.8c-16.1-6.9-38.3-10.5-45-5.6c-6.7,5-7.3,16.6,6.8,28 c14,11.4,81.8,38.2,101.8,40.2C137,246.6,135,238,135,238z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2919 -0.9564 0.9564 0.2919 -89.2148 242.9023)",
    className: "st2",
    cx: 119.4,
    cy: 181.7,
    rx: 6.2,
    ry: 6.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Requirements"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.8383770d.svg";
export { ForwardRef as ReactComponent };